export default __webpack_public_path__ + "static/media/avater2.46dd975d.png";